import { useForm } from 'react-hook-form'
import { credentialsSchema } from '../../utils/entities'
import { CredentialsType } from '../../utils/types'
import { zodResolver } from '@hookform/resolvers/zod'

export const useCredentialsForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    getValues,
    setError,
    watch,
  } = useForm<CredentialsType>({ resolver: zodResolver(credentialsSchema) })

  const onSubmit = (callback: (data: CredentialsType) => void) => {
    return handleSubmit((data) => {
      if (!data['link']) {
        setError('link', {
          type: 'required',
          message: 'Link é um campo obrigatório',
        })

        return
      }

      callback(data)
    })
  }

  return {
    register,
    handleSubmit: onSubmit,
    errors,
    clearErrors,
    setValue,
    getValues,
    setError,
    watch,
  }
}
